export default "__VITE_ASSET__9956e3e4__"